import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import { datadogLogs } from "@datadog/browser-logs";

// Import stylesheets
import "../stylesheets/application.scss";

// Read from a meta tag rather than a global set by an inline <script>, so the
// Content-Security-Policy does not need 'unsafe-inline' for this.
// Spec: SHP-17632
const environmentMeta = document.querySelector('meta[name="app-environment"]');

datadogLogs.init({
  clientToken: "pub883e282c4b8ff9456d688fdbe72fe60f",
  site: "datadoghq.eu",
  forwardErrorsToLogs: true,
  sampleRate: 100,
  service: "cortana-js",
  env: environmentMeta ? environmentMeta.content : undefined,
  beforeSend: (log) => {
    if (log.message.includes("XHR error GET")) {
      return false;
    }
  },
});

Rails.start();
Turbolinks.start();

Turbolinks.Visit.prototype.performScroll = function () {
  if (!this.scrolled) {
    if (this.action == "replace") {
      // do nothing
    } else if (this.action == "restore") {
      this.scrollToRestoredPosition() || this.scrollToTop();
    } else {
      this.scrollToAnchor() || this.scrollToTop();
    }
    this.scrolled = true;
  }
};

import "../javascript/legacy/";
import "../javascript/controllers";
